import { Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'formly-section-wrapper',
  template: `
    <div class="border border-gray-200 rounded-lg p-2 mb-2">
      @if (props.label) {
        <h3 class="text-lg font-semibold mb-2">{{ props.label }}</h3>
      }
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
  imports: [CommonModule, FormlyModule],
})
export class SectionWrapperComponent extends FieldWrapper {}
